import axios from 'axios';
import { useQuery } from 'react-query';

import {
  Anything,
  AnythingResponse,
  AnythingsResponse,
} from 'src/types/anything';
import { SortBy } from 'src/types/api-general';

export function useAnything(id: Anything['id']) {
  return useQuery<AnythingResponse, unknown, Anything>(
    ['anythings', id],
    () => axios.get(`/api/anythings/${id}`),
    {
      select: (data) => data.data,
    }
  );
}

type UseAnythingsParams = {
  limit?: number;
  sort_by?: SortBy<keyof Anything>[];
  type?: 'POSITION';
};
export function useAnythings(params: UseAnythingsParams) {
  return useQuery<AnythingsResponse, unknown, Anything[]>(
    ['anythings', params],
    () =>
      axios.get('/api/anythings', {
        params: {
          ...params,
          sort_by: params.sort_by?.join(','),
        },
      }),
    {
      select: (data) => data.data,
    }
  );
}
